module.exports = __webpack_public_path__ + "static/img/pandacare.0991dede.png";